import script from "./MediaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaModal.vue?vue&type=script&setup=true&lang=js"

import "./MediaModal.vue?vue&type=style&index=0&id=6a3e2fb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a3e2fb8"]])

export default __exports__